// extracted by mini-css-extract-plugin
export default {"link":"ImportTemplateDialog_link__Sj+KQ"};